import { useTranslations } from 'next-intl';
import CurrencyIcon from '../ui/icons/currency-icon';
import DeliveryTruck from '../icons/DeliveryTruck';
import { usePathname } from '@/i18n/navigation';
import useCart from '@/store/cart.store';
import { calcCartTotalHandler } from '@/helpers/cart';
import { FREE_DELIVERY_LIMIT } from '@/constants';

const FreeDeliveryProgress = ({ fixed = true }) => {
  const cartItems = useCart((store) => store.cartItems);
  const total = calcCartTotalHandler(cartItems || []);
  const t = useTranslations('common');
  const progress = Math.min((total / FREE_DELIVERY_LIMIT) * 100, 100);
  const remaining = Math.max(0, FREE_DELIVERY_LIMIT - total).toFixed(2);
  const hasUnlockedFreeDelivery = progress >= 100;
  const pathname = usePathname();
  const isCartPage = pathname === '/cart';

  const baseClasses = `w-full transition-colors duration-300 ${
    hasUnlockedFreeDelivery ? 'bg-green-50' : 'bg-white'
  } px-4 py-3
    sm:relative sm:bottom-auto sm:rounded-[10px] sm:border-t-0 sm:p-4`;

  const fixedClasses = fixed
    ? `fixed left-0 z-10 border-t border-gray-200 ${isCartPage ? 'bottom-14.5' : 'bottom-0'}`
    : 'rounded-[10px] ';

  return (
    <div className={`${baseClasses} ${fixedClasses}`}>
      {hasUnlockedFreeDelivery ? (
        // --- Success State ---
        <div className='flex items-center gap-3 text-green-700 max-sm:justify-center'>
          <DeliveryTruck className='h-6 w-5 shrink-0' />
          <p className='text-sm font-semibold'>{t('got_free_delivery')} 🎉</p>
        </div>
      ) : (
        // --- In-Progress State ---
        <>
          <div className='mb-0 h-3.75 w-full overflow-hidden rounded-full bg-[#DBE1EC]'>
            <div
              className='h-full rounded-full bg-[#1D72EB] transition-all duration-300'
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className='flex flex-wrap items-baseline gap-x-1.5'>
            <p className='font-bold text-black'>{t('free_delivery')}</p>
            <p className='md-text-[15px] text-sm'>
              {t.rich('spend_to_free_delivery', {
                remaining,
                currency: () => (
                  <CurrencyIcon className='inline-block size-3' />
                ),
              })}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default FreeDeliveryProgress;
